// extracted by mini-css-extract-plugin
module.exports = {"claimRow":"ClaimPassRow_claimRow_2X4o0","rowImg":"ClaimPassRow_rowImg_1m0xV"};